var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
import Link from "syf-component-library/ui/atoms/Link";
import { onEnterKeyPress } from "../AlmeUtilities/dom-utils";
const OneClickLink = (_a) => {
    var { linkText, onClick, isLinkEnabled } = _a, props = __rest(_a, ["linkText", "onClick", "isLinkEnabled"]);
    const [disabled, setDisabled] = useState(props.disabled || false);
    useEffect(() => {
        if (isLinkEnabled) {
            setDisabled(true);
        }
    }, [isLinkEnabled]);
    return (disabled
        ? React.createElement(Link, Object.assign({}, props, { to: "", isDisabled: disabled }), linkText)
        : React.createElement(Link, Object.assign({}, props, { to: "", onKeyPress: ((evt) => onEnterKeyPress(evt, () => { setDisabled(true); onClick(); })), onClick: () => { setDisabled(true); onClick(); } }), linkText));
};
export default OneClickLink;
